module.exports = __webpack_public_path__ + "assets/check.a28e8e20.svg";